<template>
    <div class="lkl">
        <h4>拉卡拉文件{{ acctType == 0 ? '对公' : '对私' }}上传</h4>
        <el-form :model="uploag" :rules="uploagRules" ref="uploagRef" label-width="240px">
            <el-form-item label="银行卡号" required>
                <el-input v-model="uploag.bankCard"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码" required>
                <el-input v-model="uploag.idCardNumber"></el-input>
            </el-form-item>
            <el-form-item label="营业执照号码" required v-if="acctType == 0">
                <el-input v-model="uploag.businessLicenseNumber"></el-input>
            </el-form-item>
            <el-row :gutter="24" v-if="acctType == 0">
                <el-col :span="12">
                    <el-form-item :label="acctType == 0 ? '法人身份证正面' : '结算人身份证正面'" required>
                        <el-upload action="/api0/station-info/upLoadStationPicture" list-type="picture-card"
                            :auto-upload="false" :on-preview="handlePictureCardPreview1" :on-change="beforeUpload1"
                            :multiple="false" :limit="1" :file-list="uploag.fileList1">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="acctType == 0 ? '法人身份证反面' : '结算人身份证反面'" required>
                        <el-upload action="/api0/station-info/upLoadStationPicture" list-type="picture-card"
                            :auto-upload="false" :on-preview="handlePictureCardPreview2" :multiple="false" :limit="1"
                            :on-change="beforeUpload2" :file-list="uploag.fileList2">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="银行卡" required>
                        <el-upload action="/api0/station-info/upLoadStationPicture" list-type="picture-card"
                            :auto-upload="false" :on-preview="handlePictureCardPreview3" :multiple="false" :limit="1"
                            :on-change="beforeUpload3" :file-list="uploag.fileList3">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="营业执照" required>
                        <el-upload action="/api0/station-info/upLoadStationPicture" list-type="picture-card"
                            :auto-upload="false" :on-preview="handlePictureCardPreview4" :multiple="false" :limit="1"
                            :on-change="beforeUpload4" :file-list="uploag.fileList4">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="24" v-else>
                <el-col :span="12">
                    <el-form-item label="身份证正面" required>
                        <el-upload action="/api0/station-info/upLoadStationPicture" list-type="picture-card"
                            :on-change="beforeUpload1" :auto-upload="false" :on-preview="handlePictureCardPreview1"
                            :multiple="false" :limit="1" :file-list="uploag.fileList1">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="身份证反面" required>
                        <el-upload action="/api0/station-info/upLoadStationPicture" list-type="picture-card"
                            :on-change="beforeUpload2" :auto-upload="false" :on-preview="handlePictureCardPreview2"
                            :multiple="false" :limit="1" :file-list="uploag.fileList2">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="银行卡" required>
                        <!-- :before-remove="beforeRemove" -->
                        <el-upload action="/api0/station-info/upLoadStationPicture" list-type="picture-card"
                            :auto-upload="false" :on-preview="handlePictureCardPreview3" :multiple="false" :limit="1"
                            :on-change="beforeUpload3" :file-list="uploag.fileList3">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <!-- 底部按钮区域 -->
        <span slot="footer" class="dialog-footer">
            <button @click="editDialogClosed">取 消</button>
            <button @click="editVinAccount" :disabled="diabledTils">
                <i class="el-icon-loading" v-if="diabledTils"></i>
                确 定
            </button>
        </span>
    </div>
</template>

<script>
export default {
    name: 'vinAccountWorld',
    data() {
        return {
            diabledTils: false,
            dialogImageUrl: '',
            dialogVisible: false,
            imgg: null,
            options2: [],
            uploag: {
                bankCard: '',
                idCardNumber: '',
                businessLicenseNumber: '',
                // file: '',
                uploadAttachContentType1: '',
                uploadAttachContentType2: "",
                uploadAttachContentType3: "",
                uploadAttachContentType4: "",
                uploadAttachType1: '',
                uploadAttachType2: '',
                uploadAttachType3: '',
                uploadAttachType4: '',
                uploadAttachName1: '',
                uploadAttachName2: '',
                uploadAttachName3: '',
                uploadAttachName4: '',
                file1: '',
                file2: '',
                file3: '',
                file4: '',
                // id: null,
                stationLedgerId: null,

            },
            imageUrl: this.$imgUrls3,
            uploagRules: {
                uploadAttachName: {
                    required: true,
                    message: '请选择文件名称',
                    trigger: 'change',
                },
                bankCard: {
                    required: true,
                    message: '请输入银行卡号',
                    trigger: 'blur',
                },
                idCardNumber: {
                    required: true,
                    message: '请输入身份证号码',
                    trigger: 'blur',
                },
                businessLicenseNumber: {
                    required: true,
                    message: '请输入营业执照号码',
                    trigger: 'blur',
                },
            },
            acctType: null,
            obj: {},
            file: '',
            acc: []
        }
    },
    computed: {

    },
    watch: {
        '$route.path': {
            handler(newPath) {
                if (!newPath) return;
                if (newPath.includes('/Lkl')) {
                    try {
                        this.diabledTils = false;
                        this.uploag = {
                            bankCard: '',
                            idCardNumber: '',
                            businessLicenseNumber: '',
                            // file: '',
                            uploadAttachContentType1: '',
                            uploadAttachContentType2: "",
                            uploadAttachContentType3: "",
                            uploadAttachContentType4: "",
                            uploadAttachType1: '',
                            uploadAttachType2: '',
                            uploadAttachType3: '',
                            uploadAttachType4: '',
                            uploadAttachName1: '',
                            uploadAttachName2: '',
                            uploadAttachName3: '',
                            uploadAttachName4: '',
                            file1: '',
                            file2: '',
                            file3: '',
                            file4: ''
                        };
                        this.acc = [];
                        // 更安全的路径解析
                        const pathParts = newPath.split('/Lkl/:');
                        this.uploag.stationLedgerId = pathParts.length > 1 ? pathParts[pathParts.length-1] : '';

                        // 调用方法前检查是否存在
                        if (typeof this.com1 === 'function') {
                            this.com1();
                        } else {
                            console.warn('com1方法未定义');
                        }
                    } catch (error) {
                        console.error('路由路径处理错误:', error);
                    }
                }
            },
            immediate: true
        }
    },
    created() { },
    methods: {
        beforeRemove() {
            return false
        },
        // 公、私
        handlePictureCardPreview1(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        // 公、私
        handlePictureCardPreview2(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        // 对公
        handlePictureCardPreview3(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        // 对公
        handlePictureCardPreview4(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        beforeUpload1(file, fileList) {
            this.uploag.uploadAttachContentType1 = file.raw.type.split('image/')[1];
            this.uploag.file1 = file.raw;
            this.uploag.uploadAttachName1 = this.acctType == 0 ? '法人身份证正面' : '结算人身份证正面';
            this.uploag.uploadAttachType1 = this.acctType == 0 ? 'FR_ID_CARD_FRONT' : 'ID_CARD_FRONT';
        },
        beforeUpload2(file, fileList) {
            this.uploag.uploadAttachContentType2 = file.raw.type.split('image/')[1];
            this.uploag.file2 = file.raw;
            this.uploag.uploadAttachName2 = this.acctType == 0 ? '法人身份证反面' : '结算人身份证反面';
            this.uploag.uploadAttachType2 = this.acctType == 0 ? 'FR_ID_CARD_BEHIND' : 'ID_CARD_BEHIND';
        },
        beforeUpload3(file, fileList) {
            this.uploag.uploadAttachContentType3 = file.raw.type.split('image/')[1];
            this.uploag.file3 = file.raw;
            this.uploag.uploadAttachName3 = this.acctType == 0 ? '营业执照' : '银行卡';
            this.uploag.uploadAttachType3 = this.acctType == 0 ? 'BUSINESS_LICENCE' : 'BANK_CARD';
        },
        beforeUpload4(file, fileList) {
            this.uploag.uploadAttachContentType4 = file.raw.type.split('image/')[1];
            this.uploag.file4 = file.raw;
            this.uploag.uploadAttachName4 = '银行卡';
            this.uploag.uploadAttachType4 = 'BANK_CARD';
        },
        imageUrlMethods() {
            const fileMapping = {
                '法人身份证正面': 'fileList1',
                '结算人身份证正面': 'fileList1',
                '法人身份证反面': 'fileList2',
                '结算人身份证反面': 'fileList2',
                '营业执照': 'fileList3',
                '银行卡': 'fileList4'
            };
            if (!this.obj.stationLedgerUploadFilesList?.length) return;
            this.obj.stationLedgerUploadFilesList.forEach(item => {
                const targetFileList = fileMapping[item.uploadAttachName];
                if (targetFileList) {
                    this.uploag[targetFileList] = [{
                        name: `${item.uploadAttachName}${item.uploadAttachContentType}`,
                        url: `${this.imageUrl}${item.picImage}`
                    }];
                }
            });
        },
        com1() {
            if (!this.uploag.stationLedgerId || this.uploag.stationLedgerId == '') {
                this.uploag.stationLedgerId = this.$route.path.split('/Lkl/:')[1];
            }
            console.log(this.uploag.stationLedgerId, this.$route.path);
            this.$http
                .get(
                    `station-ledger/getStationLedgerById/${this.uploag.stationLedgerId}`
                )
                .then((res) => {
                    this.acctType = res.data.data.acctType
                    this.obj = res.data.data;
                    if (!this.obj.stationLedgerUploadFilesList || this.obj.stationLedgerUploadFilesList.length == 0) return;
                    const {
                        uploadAttachName,
                        bankCard,
                        idCardNumber,
                        businessLicenseNumber,
                        uploadAttachType,
                        // picImage,
                    } = this.obj.stationLedgerUploadFilesList[this.obj.stationLedgerUploadFilesList.length-1];
                    this.uploag.uploadAttachName = uploadAttachName;
                    this.uploag.bankCard = bankCard;
                    this.uploag.idCardNumber = idCardNumber;
                    this.uploag.businessLicenseNumber = businessLicenseNumber;
                    this.uploag.uploadAttachType = uploadAttachType;
                    this.imageUrlMethods()
                })
        },
        editDialogClosed() {
            this.uploag = {
                bankCard: '',
                idCardNumber: '',
                businessLicenseNumber: '',
                uploadAttachContentType1: '',
                uploadAttachContentType2: "",
                uploadAttachContentType3: "",
                uploadAttachContentType4: "",
                uploadAttachType1: '',
                uploadAttachType2: '',
                uploadAttachType3: '',
                uploadAttachType4: '',
                uploadAttachName1: '',
                uploadAttachName2: '',
                uploadAttachName3: '',
                uploadAttachName4: '',
                file1: '',
                file2: '',
                file3: '',
                file4: '',
                fileList1: [],
                fileList2: [],
                fileList3: [],
                fileList4: [],
                // id: null,
                stationLedgerId: null,
            };
            this.acc = [];
            this.uploag.stationLedgerId = this.$route.path.split('/Lkl/:')[1];
            this.$store.commit('del', window.sessionStorage.getItem('activePath'));
            this.$router.push('/lklOpening');
            this.diabledTils = false;
            window.sessionStorage.setItem('activePath', 'lklOpening');
        },
        editVinAccount() {
            if (!this.uploag.bankCard || this.uploag.bankCard == '') return this.$message.error('请输入银行卡号！');
            this.uploag.bankCard =this.uploag.bankCard.replace(/\s+/g, '');
            if (!this.uploag.idCardNumber || this.uploag.idCardNumber == '') return this.$message.error('请输入身份证号码！');
            this.uploag.idCardNumber =this.uploag.idCardNumber.replace(/\s+/g, '');
            if (this.acctType == 0) {
                if (!this.uploag.businessLicenseNumber || this.uploag.businessLicenseNumber == '') return this.$message.error('请输入营业执照号码！');
                this.uploag.businessLicenseNumber =this.uploag.businessLicenseNumber.replace(/\s+/g, '');
            }
            if (this.uploag.uploadAttachName1 == '' || this.uploag.uploadAttachName2 == '' || this.uploag.uploadAttachName3 == '') return this.$message('请检查您上传的拉卡拉文件，当前信息不足！');
            this.uploag.uploadAttachName1 =this.uploag.uploadAttachName1.replace(/\s+/g, '');
            this.uploag.uploadAttachName2 =this.uploag.uploadAttachName2.replace(/\s+/g, '');
            this.uploag.uploadAttachName3 =this.uploag.uploadAttachName3.replace(/\s+/g, '');
            if (this.acctType == 0 && this.uploag.uploadAttachName4 == '') return this.$message('请检查您上传的拉卡拉文件，当前信息不足！');
            this.uploag.uploadAttachName4 =this.uploag.uploadAttachName4.replace(/\s+/g, '');
            // if (!this.obj.stationLedgerUploadFilesList || this.obj.stationLedgerUploadFilesList == '') return 
            this.$message.warning('正在上传中，请稍后...');
            this.diabledTils=true;
            this.com2();
        },
        // 添加
        com2() {
            const that = this;

            // 动态生成附件数组
            const generateAttachments = (count) => {
                return Array.from({ length: count }, (_, i) => ({
                    uploadAttachContentType: that.uploag[`uploadAttachContentType${i + 1}`],
                    file: that.uploag[`file${i + 1}`],
                    uploadAttachName: that.uploag[`uploadAttachName${i + 1}`],
                    uploadAttachType: that.uploag[`uploadAttachType${i + 1}`]
                }));
            };
            // 检查文件列表是否为空
            const shouldUploadFiles = !that.obj.stationLedgerUploadFilesList || that.obj.stationLedgerUploadFilesList === '';
            const attachmentCount = that.acctType == 0 ? 4 : 3;
            that.acc = generateAttachments(attachmentCount);
            if (!shouldUploadFiles) {
                return that.uploadFiles();
            }
            that.acc.forEach((item, index) => {
                if (that.obj[index] && item.uploadAttachName == that.obj[index].uploadAttachName) {
                    item.id = that.obj[index].id;
                }
            });
            console.log(that.acc,'384')
            that.uploadFiles()
        },
        // 编辑
        async uploadFiles() {
            try {
                const uploadPromises = this.acc.map(async (file, index) => {
                    const formData = new FormData();
                    // 添加文件特定字段
                    formData.append('uploadAttachContentType', file.uploadAttachContentType);
                    formData.append('file', file.file);
                    formData.append('uploadAttachName', file.uploadAttachName);
                    formData.append('uploadAttachType', file.uploadAttachType);
                    // 添加公共字段
                    formData.append('stationLedgerId', this.uploag.stationLedgerId);
                    formData.append('bankCard', this.uploag.bankCard);
                    formData.append('idCardNumber', this.uploag.idCardNumber);
                    formData.append('acctType', this.acctType);
                    if (this.acctType == 0) {
                        formData.append('businessLicenseNumber', this.uploag.businessLicenseNumber);
                    }
                    // 使用延迟上传，避免并发压力
                    await new Promise(resolve => setTimeout(resolve, 3000 * index));
                    const response = await this.$http.post('lkl-allowlist/upload', formData);
                    return response;
                });
                // 等待所有文件上传完成
                const results = await Promise.all(uploadPromises);
                console.log('所有文件上传完成:', results);
                // this.$message({
                //     type: 'success',
                //     message: '成功'
                // });
                // 所有文件上传成功后调用添加白名单接口
                const addResponse = await this.$http.post(
                    `lkl-allowlist/addAllowList?stationLedgerId=${this.uploag.stationLedgerId}`
                );
                // 显示结果消息
                const messageType = addResponse.data.code > 0 ? 'error' : 'success';
                this.$message({
                    type: messageType,
                    message: addResponse.data.msg
                });
                // 执行后续操作
                this.editDialogClosed();
            } catch (error) {
                console.error('上传过程出错:', error);
                this.$message({
                    type: 'error',
                    message: '文件上传失败，请重试'
                });
            }
        }
    },
}
</script>

<style lang="less" scoped>
.lkl {
    width: 100%;
    height: 100%;
    overflow-y: scroll;

    .el-form {
        width: 35%;
    }

    h4 {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
    }

    p {
        display: flex;
        flex-direction: row;
        justify-content: center;
        line-height: 25px;
        color: red;
    }

    p:nth-child(3) {
        line-height: 40px;

        button {
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px solid #c5c5c5;
            font-size: 16px;
            width: 120px;
            height: 30px;
            color: #000;
        }

        button:nth-child(2) {
            margin-left: 20px;
            border: none;
            color: #fff;
            background-color: blue;
        }
    }
}

.dialog-footer {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    // margin: 20px 1%;

    button {
        width: 160px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #409eff;
        font-size: 18px;
        color: #fff;
        border-radius: 5px;
        outline: none;
        border: none;
        margin-right: 20px;
    }

    button:nth-child(1) {
        background-color: red;
    }
}

.cool {
    display: flex;
    flex-direction: column;

    p {
        display: flex;
        flex-direction: row;
        line-height: 20px;
    }

    p:nth-child(1) {
        align-items: center;

        span {
            margin-right: 10px;
        }
    }

    p:nth-child(2) {
        justify-content: center;
        align-items: center;
    }

    p:nth-child(5) {
        justify-content: center;

        button {
            width: 120px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;

            border: 1px solid #c5c5c5;
            font-size: 16px;
            border-radius: 5px;
            background: none;
        }

        button:nth-child(2) {
            margin-left: 20px;
            background: #409eff;
            border: none;
            color: #fff;
        }
    }
}

.moneylist {
    height: 180px;
    display: flex;
    flex-direction: row;

    dl {
        flex: 1;
        display: flex;
        flex-direction: column;

        p {
            flex: 1;
            display: flex;
            align-items: center;
        }
    }
}

.cardslist {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .top,
    .center {
        flex: 2;
        display: flex;
        flex-direction: column;

        dl {
            flex: 1;
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            dt {
                // flex: 2;
                width: 200px;
                display: flex;
                align-items: center;
            }

            dd {
                // flex: 8
                width: calc(100% - 200px);
            }
        }
    }

    .top {
        font-size: 16px;

        dd {
            display: flex;
            flex-direction: row;

            li {
                flex: 1;
                display: flex;
                flex-direction: column;

                p {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }
            }

            li:nth-child(2) {
                span:nth-child(1) {
                    width: 160px;
                }
            }
        }
    }

    .center {
        border-bottom: 1px solid gray;
        border-top: 1px solid gray;
        padding-bottom: 20px;

        dl {
            flex: 9;
        }

        dd {
            display: flex;
            flex-direction: column;

            li {
                display: flex;
                flex-direction: row;

                p {
                    margin-right: 30px;
                    display: flex;
                    flex-direction: column;

                    span:nth-child(1) {
                        font-size: 16px;
                        width: 125px;
                        color: gray;
                    }

                    span:nth-child(2) {
                        color: blue;
                        font-size: 32px;
                        display: flex;
                        margin-top: 10px;
                        justify-content: center;
                    }
                }
            }
        }

        .footername {
            flex: 1;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            font-size: 16px;

            span {
                flex: 1;
                color: blue;
            }
        }
    }

    .bottom {
        display: flex;
        flex-direction: column;
        font-size: 16px;

        h4 {
            padding: 20px 0;
        }
    }

    .center,
    .bottom.top {
        flex: 3;
    }

    .footer {
        flex: 1;
        display: flex;
        flex-direction: column;
        font-size: 16px;

        li {
            flex: 1;
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            p {
                flex: 1;
                display: flex;
                flex-direction: row;
                align-items: center;
            }
        }
    }
}

.listname {
    display: flex;
    flex-direction: row;
    height: 120px;
    justify-content: space-between;
    padding: 0 20px;
    margin-bottom: 20px;
    border: 1px solid gray;
    list-style: none;
    border-radius: 15px;

    .dl {
        flex: 1;
        display: flex;
        flex-direction: column;
        margin-right: 20px;

        p {
            flex: 1;
            display: flex;
            justify-content: center;
            font-size: 18px;
        }

        p:nth-child(1) {
            color: gray;
            font-size: 16px;
        }
    }

    .dl:last-child {
        margin-right: 0;
    }
}
</style>